(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strata-product-details"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('strata-purchase')) {

  customElements.define('strata-purchase', class extends HTMLElement {

    connectedCallback() {

      if (this.ready) return;

      this.ready = true;

      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);

      const currency = JSON.parse(this.querySelector('[data-currency]').textContent);

      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency});

      this.select = this.querySelector('[data-variant]');

      this.quantity = this.querySelector('[data-quantity]');

      this.select.addEventListener('change', () => this.update(true));

      this.quantity.addEventListener('input', () => this.syncQuantity());

      this.quantity.addEventListener('change', () => this.syncQuantity());

      this.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {

        if (button.disabled) return;

        this.quantity.value = button.dataset.qty;

        this.quantity.dispatchEvent(new Event('input', {bubbles:true}));

        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));

      }));

      this.querySelectorAll('[data-show-media]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.showMedia)));

      this.update(false);

    }

    showMedia(id) {

      if (!this.querySelector('[data-media="'+id+'"]')) return;

      this.querySelectorAll('[data-media]').forEach(panel => {

        panel.hidden = panel.dataset.media !== String(id);

        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());

      });

      this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === String(id))));

    }

    syncQuantity() {

      const quantity = Number(this.quantity.value);

      const cards = Array.from(this.querySelectorAll('[data-qty]'));

      cards.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.qty) === quantity)));

      const variant = this.variants.find(item => String(item.id) === this.select.value);

      if (!variant || !Number.isInteger(quantity) || quantity < 1) return;

      const selectedCard = cards.find(button => Number(button.dataset.qty) === quantity);

      const discount = selectedCard ? Number(selectedCard.dataset.discount) : 0;

      const regularTotal = variant.price * quantity;

      const total = Math.round(regularTotal * (100 - discount) / 100);

      this.querySelector('[data-price]').textContent = this.format.format(total / 100);

      const compare = this.querySelector('[data-compare]');

      const compareTotal = discount > 0 ? regularTotal : variant.compare * quantity;

      compare.textContent = this.format.format(compareTotal / 100);

      compare.hidden = !(compareTotal > total);

    }

    update(changeUrl) {

      const variant = this.variants.find(item => String(item.id) === this.select.value);

      if (!variant) return;

      const atc = this.querySelector('[data-add]');

      atc.disabled = !variant.available;

      atc.textContent = variant.available ? 'Add to cart' : 'Sold out';

      this.querySelector('[data-stock]').innerHTML = variant.available ? '<i></i> In Stock' : 'Sold Out';

      this.quantity.min = variant.min;

      this.quantity.step = variant.step;

      if (variant.max == null) this.quantity.removeAttribute('max'); else this.quantity.max = variant.max;

      const current = Number(this.quantity.value);

      if (!Number.isInteger(current) || current < variant.min || (variant.max != null && current > variant.max) || (current - variant.min) % variant.step !== 0) this.quantity.value = variant.min;

      this.querySelectorAll('[data-qty]').forEach(button => {

        const qty = Number(button.dataset.qty);

        button.disabled = !variant.available || qty < variant.min || (variant.max != null && qty > variant.max) || (qty - variant.min) % variant.step !== 0;

        const cents = Math.round(variant.price * qty * (100 - Number(button.dataset.discount)) / 100);

        button.querySelector('[data-total]').textContent = this.format.format(cents / 100);

      });

      this.syncQuantity();

      if (variant.media) this.showMedia(variant.media);

      if (changeUrl) {

        const url = new URL(window.location.href);

        url.searchParams.set('variant', variant.id);

        window.history.replaceState({}, '', url);

      }

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strata-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('strata-product')) {
  customElements.define('strata-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const currency = JSON.parse(this.querySelector('[data-currency]').textContent);
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency});
      this.select = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[data-quantity]');
      this.select.addEventListener('change', () => this.update(true));
      this.quantity.addEventListener('input', () => this.syncQuantity());
      this.quantity.addEventListener('change', () => this.syncQuantity());
      this.querySelectorAll('[data-qty]').forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        this.quantity.value = button.dataset.qty;
        this.quantity.dispatchEvent(new Event('input', {bubbles:true}));
        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      this.querySelectorAll('[data-show-media]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.showMedia)));
      this.update(false);
    }
    showMedia(id) {
      if (!this.querySelector('[data-media="'+id+'"]')) return;
      this.querySelectorAll('[data-media]').forEach(panel => {
        panel.hidden = panel.dataset.media !== String(id);
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === String(id))));
    }
    syncQuantity() {
      const quantity = Number(this.quantity.value);
      const cards = Array.from(this.querySelectorAll('[data-qty]'));
      cards.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.qty) === quantity)));
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      if (!variant || !Number.isInteger(quantity) || quantity < 1) return;
      const selectedCard = cards.find(button => Number(button.dataset.qty) === quantity);
      const discount = selectedCard ? Number(selectedCard.dataset.discount) : 0;
      const regularTotal = variant.price * quantity;
      const total = Math.round(regularTotal * (100 - discount) / 100);
      this.querySelector('[data-price]').textContent = this.format.format(total / 100);
      const compare = this.querySelector('[data-compare]');
      const compareTotal = discount > 0 ? regularTotal : variant.compare * quantity;
      compare.textContent = this.format.format(compareTotal / 100);
      compare.hidden = !(compareTotal > total);
    }
    update(changeUrl) {
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      if (!variant) return;
      const atc = this.querySelector('[data-add]');
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? 'Add to cart' : 'Sold out';
      this.querySelector('[data-stock]').innerHTML = variant.available ? '<i></i> In Stock' : 'Sold Out';
      this.quantity.min = variant.min;
      this.quantity.step = variant.step;
      if (variant.max == null) this.quantity.removeAttribute('max'); else this.quantity.max = variant.max;
      const current = Number(this.quantity.value);
      if (!Number.isInteger(current) || current < variant.min || (variant.max != null && current > variant.max) || (current - variant.min) % variant.step !== 0) this.quantity.value = variant.min;
      this.querySelectorAll('[data-qty]').forEach(button => {
        const qty = Number(button.dataset.qty);
        button.disabled = !variant.available || qty < variant.min || (variant.max != null && qty > variant.max) || (qty - variant.min) % variant.step !== 0;
        const cents = Math.round(variant.price * qty * (100 - Number(button.dataset.discount)) / 100);
        button.querySelector('[data-total]').textContent = this.format.format(cents / 100);
      });
      this.syncQuantity();
      if (variant.media) this.showMedia(variant.media);
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
